<template>
  <v-container>
    <h1>Guidelines</h1>
    <p>These guidelines will help you develop shared components</p>

    <h2>Component Examples</h2>
    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab aliquid amet blanditiis consectetur deserunt dignissimos doloribus, et inventore ipsa, laboriosam maiores nam nemo nihil nostrum qui quibusdam quidem repudiandae sint!</p>

    <h2>Adding Comments to Components</h2>
    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquam animi asperiores cum eos illum ipsa iure nemo nihil non, nostrum reiciendis suscipit. Commodi culpa ipsa, iure modi nostrum optio sint!</p>

    <h2>ESLint Rules</h2>
    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus esse eum in, nemo quaerat quia sit. Commodi dicta fugiat laborum repudiandae voluptatem. Autem cumque laboriosam nostrum, praesentium ratione sapiente vitae.</p>
  </v-container>
</template>

<script>
export default {
  name: 'Guidelines',
};
</script>

<style lang="scss" scoped>

</style>
